import DonateCryptoPage from "src/pages/CryptoLanding";
export default DonateCryptoPage;
